import React, { useEffect, useState } from "react";
import { AutoFormFieldProps } from "@autoform/react";
import AddressAutoComplete, {
  AddressType,
} from "@components/ui/address-autocomplete";
import { useAutoFormDefaultValues } from "@components/ui/autoform";

export const AddressField: React.FC<AutoFormFieldProps> = ({
  inputProps,
  error,
  id,
  field,
  path,
  control,
}) => {
  const defaultValues = useAutoFormDefaultValues();
  const { key, ref, ...props } = inputProps;

  const [address, setAddress] = useState<AddressType>(
    // @ts-ignore
    defaultValues[path.join(".")] ?? {
      address1: "",
      address2: "",
      formattedAddress: "",
      city: "",
      region: "",
      postalCode: "",
      country: "",
      lat: 0,
      lng: 0,
    },
  );

  // workaround for values not changing once registered, since this library doesnt expose `watch` yet
  useEffect(() => {
    Object.keys(address).forEach((k) => {
      control.unregister(`${path.join(".")}.${k}`);
    });
  }, [address]);

  const [searchInput, setSearchInput] = useState("");
  return (
    <>
      <AddressAutoComplete
        // ref={ref}
        id={id}
        key={key}
        className={error ? "border-destructive" : ""}
        address={address}
        setAddress={setAddress}
        searchInput={searchInput}
        setSearchInput={setSearchInput}
        dialogTitle="Enter Address"
        {...props}
      />
      {Object.values(field.schema!).map((subField) => {
        const value = address[subField.key as keyof AddressType] ?? "..";
        console.log(control, 'ctrl')

        const controller = control.register(
          `${path.join(".")}.${subField.key}`,
          { value, shouldUnregister: true },
        );

        return (
          <input
            name={controller.name}
            ref={controller.ref}
            onChange={controller.onChange}
            {...subField}
            type="hidden"
            key={`${path.join(".")}.${subField.key}-${value}`}
          />
        );
      })}
    </>
  );
};
